export const fetchEvents = ({owner, calendar, startDate, endDate, resident_id}) => {
  return (dispatch, getState) => {
    const {filter, current_user } = getState()
    dispatch({
      type: "START_FETCHING_EVENTS", 
      payload: { calendar: { id: calendar } }
    })

    var url
    if (resident_id){
      url = `/events?by_resident[]=${resident_id}&start=${startDate}&end=${endDate}` 
    } else if (current_user.calendarId == calendar) {
      url = `/events?by_user[]=${current_user.id}&start=${startDate}&end=${endDate}` 
    } else {
      url = `/events?by_calendar[]=${calendar}&start=${startDate}&end=${endDate}`
    }

    return fetch(encodeURI(url), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }).then(response => {
      return response.json()
    }).then(events => {
      dispatch({ 
        type: "FETCH_EVENTS", 
        payload: {
          filter: filter,
          events,
          calendar: { id: calendar }
        } })
      return
    })
  }
}